<div class="alarm-bell">
  <nb-icon nbPrefix icon="bell" pack="eva" status="control" class="alarm-bell-icon"></nb-icon>
  <div *ngIf="alarmGoing" class="alarm-going">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      [attr.fill]="color"
      class="alarm-svg tiny"
      viewBox="0 0 16 16"
    >
      <circle
        [attr.cx]="size"
        [attr.cy]="size"
        [attr.r]="radius"
        [attr.stroke]="'black'"
        [attr.stroke-width]="2"
      ></circle>
    </svg>
  </div>
</div>
